import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { forwardRef } from "react";

import { cn } from "@/lib/utils";

import CheckedSquare from "./CheckedSquare";
import UncheckedSquare from "./UncheckedSquare";

const DropdownMenuCheckboxItemNoIndicator = forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.CheckboxItem>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.CheckboxItem>
>(({ className, children, checked = false, ...props }, ref) => (
  <DropdownMenuPrimitive.CheckboxItem
    ref={ref}
    className={cn(
      "relative flex cursor-default select-none items-center gap-[10px] rounded-sm py-1.5 pr-5 pl-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    )}
    checked={checked}
    {...props}
  >
    {checked ? <CheckedSquare /> : <UncheckedSquare />}
    {children}
  </DropdownMenuPrimitive.CheckboxItem>
));

DropdownMenuCheckboxItemNoIndicator.displayName =
  "DropdownMenuCheckboxItemNoIndicator";

export default DropdownMenuCheckboxItemNoIndicator;
